<ng-container *ngIf="showAdvisoryFeeAnnualizedDialog; else noYield">
	<dz-modal-header class="modal-header">
		<h1 class="dz-text-28-extra-bold" dcrHTMLKey="ADVISORY_FEE_ANNUALIZED_DIALOG_TITLE">Advisory Fee will now be annualized</h1>
	</dz-modal-header>
	<dz-modal-content class="text-align-center text-14 modal-content">
		<div dcrHTMLKey="ADVISORY_FEE_ANNUALIZED_DIALOG_TEXT">By adding the portfolio's twelve month trailing yield from the scenario results.</div>
	</dz-modal-content>
</ng-container>

<ng-template #noYield>
	<dz-modal-header class="modal-header">
		<h1 class="dz-text-28-extra-bold" dcrHTMLKey="ADVISORY_FEE_NOT_ANNUALIZED_DIALOG_TITLE">Advisory Fee will now be 1/365th</h1>
	</dz-modal-header>
	<dz-modal-content class="text-align-center text-14 modal-content">
		<div dcrHTMLKey="ADVISORY_FEE_NOT_ANNUALIZED_DIALOG_TEXT">By removing twelve month trailing yield from the scenario results.</div>
	</dz-modal-content>
</ng-template>

<dz-modal-actions align="between">
	<button dz-button color="secondary" (click)="onCancel()" dcrHTMLKey="ADVISORY_FEE_CHANGE_INFO_DIALOG_CANCEL">Cancel</button>
	<button dz-button (click)="onContinue()" data-cy="advisor-fee-change-info-dialog-save" dcrHTMLKey="ADVISORY_FEE_CHANGE_INFO_DIALOG_CONTINUE">Continue</button>
</dz-modal-actions>
